import { MarketingStepsRow, type MarketingStepItem } from '@/components/marketing/blocks/marketing-steps-row'
import { MARKETING_SECTION_TITLE } from '@/components/marketing/marketing-typography'
import { cn } from '@/lib/utils'

const INSIGHTS = [
  {
    title: 'Appointment summary ready',
    body: 'Symptoms, medications and recent results organised into a clinician-friendly view.',
  },
  {
    title: 'Pattern detected',
    body: 'Sleep disruption appears to align with symptom flare entries over the past 21 days.',
  },
  {
    title: 'Data connected',
    body: 'Wearable, pathology and medication history are now linked in your timeline.',
  },
] as const

const STEPS: MarketingStepItem[] = [
  { number: '01', title: 'Bring data in', description: 'Connect the health information you already have.' },
  { number: '02', title: 'Make sense of it', description: 'Turn scattered information into useful summaries and patterns.' },
  { number: '03', title: 'Use it in care', description: 'Share what matters with your healthcare team.' },
]

export function LumieProductShowcase() {
  return (
    <div className="grid items-center gap-[60px] lg:grid-cols-[0.85fr_1.15fr]">
      <div className="mx-auto w-full max-w-[360px]">
        <div className="rounded-[44px] bg-[#111] p-3.5 shadow-[0_40px_120px_rgba(31,37,40,0.2)]">
          <div className="min-h-[620px] rounded-[32px] bg-gradient-to-b from-[#fffdf7] to-[#f7f1df] p-[26px]">
            <h4 className="mb-1 text-xl font-semibold text-[var(--marketing-text,#1f2528)]">Your Health Story</h4>
            <p className="mb-[22px] text-[var(--marketing-muted,#667078)]">Today&apos;s connected insights</p>
            {INSIGHTS.map((insight) => (
              <div
                key={insight.title}
                className={cn(
                  'mb-3.5 rounded-[22px] border border-[var(--marketing-border,#e9e3d6)] bg-white p-[18px]',
                  'shadow-[0_14px_30px_rgba(31,37,40,0.04)]'
                )}
              >
                <strong className="mb-1.5 block text-[var(--marketing-text,#1f2528)]">{insight.title}</strong>
                <span className="text-sm leading-relaxed text-[var(--marketing-muted,#667078)]">{insight.body}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div>
        <h2 className={cn('m-0 mb-[18px] max-w-[800px]', MARKETING_SECTION_TITLE)}>
          Designed to make healthcare conversations easier.
        </h2>
        <p className="mb-0 max-w-[760px] text-lg leading-relaxed text-[var(--marketing-muted,#667078)]">
          Lumie is not here to replace your doctor. It helps you arrive prepared, with your information organised and
          your story easier to explain.
        </p>
        <MarketingStepsRow steps={STEPS} />
      </div>
    </div>
  )
}
